export default __webpack_public_path__ + "static/media/mp3@2x.41fed34d.png";